module.exports = __webpack_public_path__ + "img/newsImg.b528085c.png";